'use strict';

module.exports = require('./Progress');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-progress/lib/index.js
 ** module id = 336
 ** module chunks = 0
 **/